enum BillingPeriodStatus {
    OPEN = "OPEN",
    CLOSED = "CLOSED",
    BILLED = "BILLED",
    REMOVED = "REMOVED"
}

export default BillingPeriodStatus;